import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLink,
  FaLinkedin,
} from "react-icons/fa";
import { FaGlobe } from "react-icons/fa";

const BoardofdirectDetails = () => {
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 230, behavior: "smooth" });
    }, 100);
  }, []);

  const location = useLocation();
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const bioData = location.state?.bioData || {
    memberName: "",
    organizationName: "",
    imagePath: "",
    designation: "",
    energyFields: [],
  };

  const {
    memberName = "",
    organizationName = "",
    imagePath = "",
    designation = "",
    address = "",
    experiance = "",
    energyFields = [],
  } = bioData;

  const getLinkIcon = (url) => {
    if (!url) return <FaLink />;
    try {
      const domain = new URL(url.startsWith("http") ? url : `https://${url}`)
        .hostname;
      if (domain.includes("facebook.com")) return <FaFacebook />;
      if (domain.includes("twitter.com")) return <FaTwitter />;
      if (domain.includes("instagram.com")) return <FaInstagram />;
      if (domain.includes("linkedin.com")) return <FaLinkedin />;
    } catch (err) {
      console.warn("Invalid URL in getLinkIcon:", url);
    }
    return <FaLink />;
  };

  return (
    <div className="board_details">
      <div>
        <div className="container-fluid  ktig_services_page position-relative p-0">
          <Header />
        </div>

        <div className="container-fluid boardmember_bread bg-breadcrumb">
          <div
            className="container text-center py-5"
            style={{ maxWidth: "900px" }}
          >
            <h4 className="text-white display-4 mb-4 wow fadeInDown">
              Behind the Lens: The Director's Story
            </h4>
          </div>
        </div>

        <div className="container-fluid innercontain py-5 ktig_services_page directs_details overflow-hidden">
          <div className="container pt-3">
            <div className="row directors_inner">
              <div
                className="col-lg-5 p-0 mt-0 ktig_lp wow fadeInLeft"
                data-wow-delay="0.2s"
              >
                <div className="about-img w-100 directors_photo">
                  <img
                    src={imagePath}
                    alt={memberName}
                    className="img-fluid w-100"
                  />
                </div>
              </div>

              <div
                className="col-lg-7 mt-0 directors_title wow fadeInRight"
                data-wow-delay="0.2s"
              >
                <div className="about-item col-lg-10 my-auto">
                  <h3 className="mb-4 text-white">{memberName}</h3>
                  <p className="text-white designation_text pt-3">
                    {designation}
                  </p>
                  <p className="text-white companynames pt-3">
                    {organizationName}
                  </p>
                  <p className="text-white addresstag pt-3">{address}</p>
                  <p className="text-white experiencetag pt-3">{experiance}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="overlaygradient pb-5 mb-5 ktig_services_page container-fluid">
          <div className="container py-6">
            <div
              className="col-10 text-left mx-auto pb-2 wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h3 className="text-white success_title mb-3">
                Awards and Recognition
              </h3>
              <a className="backtopboard" href="/board-of-directories">
                <i className="fa fa-arrow-right pe-2"></i> Back to Board
              </a>
            </div>

            <div
              className="col-lg-10 col-xl-10 m-auto wow fadeInRight"
              data-wow-delay="0.2s"
            >
              {energyFields.map((field, index) => (
                <div key={index} className="service-item rounded p-4 mb-4">
                  <div className="d-flex">
                    <div className="pe-3">
                      <div className="service-btn details_board_title">
                        <p>Energy</p>
                      </div>
                    </div>
                    <div>
                      <h5 className="text-white d-inline-block mb-2">
                        {field.energyTitle}
                      </h5>

                      {field.energySubTitle?.trim() && (
                        <p className="small_caption">{field.energySubTitle}</p>
                      )}

                      {field.energyDescription?.trim() && (
                        <p className="mb-2 text-white">
                          {field.energyDescription}
                        </p>
                      )}

                      {/* Group additional fields */}
                      {(() => {
                        const nonLinkFields = field.additionalFields.filter(
                          (f) => f.type !== "link"
                        );
                        const webLinks = field.additionalFields.filter(
                          (f) => f.type === "link"
                        );

                        return (
                          <>
                            {nonLinkFields.map((addField, addIndex) => {
                              let parsedList = [];
                              if (addField.type === "list") {
                                try {
                                  parsedList = Array.isArray(addField.value)
                                    ? addField.value
                                    : JSON.parse(addField.value);
                                } catch (error) {
                                  console.error(
                                    "Failed to parse list:",
                                    addField.value,
                                    error
                                  );
                                }
                              }

                              return (
                                <div key={addIndex} className="mt-2">
                                  {addField.type === "paragraph" && (
                                    <p className="text-white">
                                      {addField.value}
                                    </p>
                                  )}
                                  {addField.type === "text" && (
                                    <span className="text-white subjectitletag d-block">
                                      {addField.value}
                                    </span>
                                  )}
                                  {addField.type === "web-link" &&
                                    addField.webLinkURL && (
                                      <a
                                        href={
                                          addField.webLinkURL.startsWith("http")
                                            ? addField.webLinkURL
                                            : `https://${addField.webLinkURL}`
                                        }
                                        className=" weblinktag small_caption d-block text-decoration-underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {addField.webLinkText ||
                                          addField.webLinkURL}
                                        <FaGlobe size={24} color="#fffff" />
                                      </a>
                                    )}

                                  {addField.type === "link" &&
                                    addField.linkURL && (
                                      <a
                                        href={
                                          addField.linkURL.startsWith("http")
                                            ? addField.linkURL
                                            : `https://${addField.linkURL}`
                                        }
                                        className="text-white d-block text-decoration-underline"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {getLinkIcon(addField.linkURL)}
                                      </a>
                                    )}

                                  {addField.type === "list" &&
                                    parsedList.length > 0 && (
                                      <ul className="text-white listitemtag ps-4">
                                        {parsedList.map((item, i) => (
                                          <li key={i}>{item}</li>
                                        ))}
                                      </ul>
                                    )}
                                </div>
                              );
                            })}

                            {/* Grouped social icons */}
                            {webLinks.length > 0 && (
                              <div className="socialwrap">
                                <div className="d-flex gap-3 flex-wrap align-items-center">
                                  {webLinks.map((link, i) => (
                                    <a
                                      key={i}
                                      href={
                                        link.linkURL.startsWith("http")
                                          ? link.linkURL
                                          : `https://${link.linkURL}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-white fs-4"
                                    >
                                      {getLinkIcon(link.linkURL)}
                                    </a>
                                  ))}
                                </div>
                              </div>
                            )}
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <Footer />

        <button
          className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
          onClick={() => window.scrollTo(0, 0)}
        >
          <i className="fa fa-arrow-up"></i>
        </button>
      </div>
    </div>
  );
};

export default BoardofdirectDetails;
